<div
	[class.h-[60vh]]="!(controller.isHandsetLandscape$ | async)"
	[class.h-screen]="controller.isHandsetLandscape$ | async"
	class="flex w-full"
>
	<p-card
		[styleClass]="(controller.isHandsetLandscape$ | async) ? '' : 'h-full'"
		class="w-full"
	>
		<div
			[class.h-full]="!(controller.isHandsetLandscape$ | async)"
			[class.h-screen]="controller.isHandsetLandscape$ | async"
			class="flex flex-col"
		>
			<spr-coachee-profile-documents-header></spr-coachee-profile-documents-header>
			<spr-coachee-profile-documents-filter></spr-coachee-profile-documents-filter>
			<div class="flex-1 relative">
				<ng-scrollbar
					(reached)="onReached()"
					class="absolute inset-0"
					infiniteScroll
					visibility="hover"
				>
					<spr-coachee-profile-documents-document
						*ngFor="let document of controller.documents$ | async"
						[document]="document"
					>
						<ng-container
							*ngLet="{ localization: document.localization$ | async } as data"
						>
							<p-button
								(onClick)="onViewDocumentClick(data.localization)"
								icon="fak fa-str-eye text-lg"
								styleClass="p-button-outlined border-none"
							></p-button>
							<p-button
								(onClick)="onDownloadDocumentClick(data.localization)"
								icon="fak fa-str-download text-lg"
								styleClass="p-button-outlined border-none"
							></p-button>
						</ng-container>
					</spr-coachee-profile-documents-document>
				</ng-scrollbar>
			</div>
		</div>
	</p-card>
</div>
